import { call, put, takeLatest } from "redux-saga/effects";
import { ApiCallSaga } from "../../api";
import { WATCH_TEAMS } from "../../redux/actionTypes";

function* fetchTeamsList(action) {
  const response = yield call(ApiCallSaga, "post", "get_teams", action.data);
  if (response.data.status) {
    const responseData = response.data;
    yield put({
      type: "SET_TEAMS_DATA",
      data: responseData,
      index: action.data.page,
    });
  } else {
    yield put({ type: "SET_TEAMS_STATIC" });
  }
}

export function* watchTeamsFunc() {
  yield takeLatest(WATCH_TEAMS, fetchTeamsList);
}
